import { combineReducers } from 'redux';

import { catalogsReducer } from './catalogs';
import { experimentsReducer } from './experiments';
import { geoLocationReducer } from './geoLocation';
import { halfScreenBannerReducer } from './halfScreenBanner';
import { newOfferFormReducer } from './newOfferForm';
import { newbuildingsSearchUrlReducer } from './newbuildingsSearchUrl';
import { pageReducer } from './page';
import { pageServicesReducer } from './pageServices';
import { pikPromoBannerReducer } from './pikPromoBanner';
import { quickFiltersReducer } from './quickFilters';
import { quickLinksReducer } from './quickLinks';
import { regionIdReducer } from './regionId';
import { regionsReducer } from './regions';
import { seoReducer } from './seo';
import { seoCrossLinksReducer } from './seoCrossLinks';
import { servicesReducer } from './services';
import { subdomainReducer } from './subdomain';
import { userReducer } from './user';
import { IApplicationState, TReduxActions } from '../types/redux';

export const reducers = combineReducers<IApplicationState, TReduxActions>({
  user: userReducer,
  geoLocation: geoLocationReducer,
  subdomain: subdomainReducer,
  quickFilters: quickFiltersReducer,
  quickLinks: quickLinksReducer,
  newOfferForm: newOfferFormReducer,
  regions: regionsReducer,
  seo: seoReducer,
  services: servicesReducer,
  pageServices: pageServicesReducer,
  catalogs: catalogsReducer,
  page: pageReducer,
  halfScreenBanner: halfScreenBannerReducer,
  experiments: experimentsReducer,
  pikPromoBanner: pikPromoBannerReducer,
  crossLinks: seoCrossLinksReducer,
  newbuildingsSearchUrl: newbuildingsSearchUrlReducer,
  regionId: regionIdReducer,
});
